<script>
    import * as animateScroll from "svelte-scrollto";
    import Header from './Header.svelte';
    import Footer from './Footer.svelte';
    let y = 1000;

    animateScroll.setGlobalOptions({
        offset: 200,
        onStart: (element, offset) => {
            if(element) {
                console.log("Start scrolling to element:", element);
            } else if(offset) {
                console.log("Start scrolling to page offset: (${offset.x}, ${offset.y})");
            }
        }
    })
</script>
<svelte:window bind:scrollY={y}/>
<Header />
    <slot />
<Footer />
<a href="https://wa.me/919060090777" class="whatsapp-btn" target="_blank">
	<img src="/images/whatsapp-01.png" class="img-fluid" alt="whatsapp">
</a>
{#if y}
    <button class="top-scroll-btn" on:click={() => animateScroll.scrollToTop()}>
        <i class="fa fa-angle-up" aria-hidden="true"></i>
    </button>
{/if}
<style>
    .top-scroll-btn {
        background-color: rgba(15,36,83,0.6);
        color: #fff;
        border: none;
        position: fixed;
        bottom: 100px;
        right: 20px;
        width: 50px;
        height: 50px;
        z-index: 9;
    }

    .whatsapp-btn {	
		position: fixed;
		background: none;
		border: none;
		bottom: 35px;
		left: 10px;
		z-index: 99;
	}
	
	.whatsapp-btn img {
		width: 32px;
		height: 32px;
		z-index: 99;
	}
</style>